import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  & > :first-child {
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    text-align: left;
  }
`;
export const CalendarOption = styled.button<{ active: boolean }>`
  display: flex;
  padding: 8px 16px;
  align-items: center;
  gap: 16px;
  justify-content: space-between;
  align-self: stretch;
  border-radius: 4px;
  transition: all 0.3s ease;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: ${({ theme, active }) => (active ? theme.colors.green9 : theme.colors.black8)};
  border: 1px solid ${({ theme, active }) => (active ? theme.colors.green7 : theme.colors.black2)};
  background: ${({ theme, active }) => (active ? theme.colors.green1 : theme.colors.white)};
  &:hover {
    border: 1px solid ${({ theme, active }) => (active ? theme.colors.green7 : theme.colors.black3)};
    background: ${({ theme, active }) => (active ? theme.colors.green1 : theme.colors.black1)};
  }
`;
export const TextWrapper = styled.div`
  text-align: center;
`;

export const FooterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  cursor: pointer;

  @media (min-width: ${({ theme }) => theme.mediaQueries.xs}) {
    flex-direction: row;
  }
`;

export const DateWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 7px 15px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  border: 1px solid ${({ theme }) => theme.colors.black2};
  text-transform: capitalize;

  @media (min-width: ${({ theme }) => theme.mediaQueries.xs}) {
    border-bottom-left-radius: 5px;
    border-top-right-radius: 0px;
    width: auto;
  }
`;

export const CalendarOptionsWrapper = styled.div`
  display: flex;
  padding: 8px 0 12px 0px;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;
`;
export const ButtonWrapper = styled.div`
  display: flex;
  padding: 16px 0px;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  align-self: stretch;
  & > :first-child {
    padding: 5px 12px;
  }
`;
export const RadioWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;
